<template>
    
    <span v-bind:class="{ 'vlr-neg': parseFloat(valor)<0, 
                    'vlr-pos': parseFloat(valor)>=0 }">{{ parseFloat(valor) | toCurrency }}</span>

</template>


<script>
export default {
    name : 'SpanValor',
    props : ["valor"]
}
</script>

<style scoped>

  .vlr-pos{
    color: blue;      
    float: right;
  }

  .vlr-neg{
    color:red;
    float: right;
  }

</style>